import React, { useEffect, useRef, useState } from "react";
import { Lightbulb } from "lucide-react";
import "./PracticeAssist.css";

export function PracticeAssistToggle({ enabled, onToggle }) {
  const [expanded, setExpanded] = useState(false);
  const [displayedState, setDisplayedState] = useState(enabled);
  const collapseTimeoutRef = useRef(null);

  useEffect(
    () => () => {
      if (collapseTimeoutRef.current) clearTimeout(collapseTimeoutRef.current);
    },
    []
  );

  const handleClick = () => {
    const nextEnabled = onToggle();
    setDisplayedState(nextEnabled);
    setExpanded(true);
    if (collapseTimeoutRef.current) clearTimeout(collapseTimeoutRef.current);
    collapseTimeoutRef.current = setTimeout(() => setExpanded(false), 1100);
  };

  return (
    <button
      type="button"
      className={`practice-assist-toggle ${enabled ? "practice-assist-toggle--enabled" : ""} ${expanded ? "practice-assist-toggle--expanded" : ""}`}
      onClick={handleClick}
      role="switch"
      aria-checked={enabled}
      aria-label={`Turn Assist ${enabled ? "off" : "on"}`}
      title={`Assist ${enabled ? "on" : "off"}`}
    >
      <span className="practice-assist-toggle-label">Assist {displayedState ? "on" : "off"}</span>
      <Lightbulb size={26} aria-hidden="true" />
    </button>
  );
}

export function PracticeAssistNote({ message }) {
  if (!message) return null;

  return (
    <div className="practice-assist-note" role="status" aria-live="polite">
      <Lightbulb size={21} aria-hidden="true" />
      <span>{message}</span>
    </div>
  );
}
